// Navigation visibility only: each operation is also authorized by the backend.
const routePermissions = {
  '/home': ['orders:view'],
  '/landing_page': ['dashboard:view'],
  '/lista_prodotti': ['products:view'],
  '/mappa_tavoli': ['tables:view'],
  '/comande': ['orders:view'],
  '/prenotazione': ['reservations:view'],
  '/lista_prenotazioni': ['reservations:view'],
  '/stampa_prenotazioni': ['reservations:view'],
  '/lista_comande': ['orders:view'],
  '/clienti': ['clients:view'],
  '/statistiche': ['stats:view'],
  '/utenti': ['users:view'],
  '/menu': ['products:view'],
  '/categorie': ['categories:view'],
  '/varianti': ['products:view'],
  '/punto_cassa': ['receipts:manage'],
  '/comunicazioni': ['reservations:view'],
  '/fatturazione': ['invoice:view'],
  '/documenti-emessi': ['receipts:view'],
  '/allestimenti-sale': ['products:view'],
  '/allestimenti-congressi': ['products:view'],
  '/tipi-utilizzo': ['products:view'],
  '/reparti': ['users:view'],
  '/preventivi': ['reservations:view'],
  '/planning': ['reservations:view'],
  '/logs': ['logs:view'],
  '/impostazioni-sistema': ['settings:view'],
  '/settings': ['settings:view'],
  '/storico-ordini-cliente': ['orders:view'],
  '/menu-prezzo-fisso': ['orders:view'],
  '/monitor-eventi': ['reservations:view'],
  '/spa/dashboard': ['spa-reports:view'],
  '/spa/operations': ['spa-appointments:view'],
  '/spa/clients': ['spa-clients:view'],
  '/spa/waitlist': ['spa-appointments:view'],
  '/spa/clients/new': ['spa-clients:view'],
  '/spa/reports': ['spa-reports:view'],
  '/spa/planner': ['spa-appointments:view'],
  '/spa/catalog': ['spa-catalogs:view'],
  '/spa/finance': ['spa-finance:view'],
  '/spa/communications': ['spa-settings:view'],
};

const dynamicRoutePermissions = [
  { pattern: /^\/spa\/clients\/[1-9]\d*\/clinical$/, permissions: ['spa-clinical:view'] },
  { pattern: /^\/spa\/clients\/[^/]+$/, permissions: ['spa-clients:view'] },
];

export function spaHomeRoute(canVisit) {
  return ['/spa/dashboard', '/spa/operations', '/spa/clients', '/spa/finance', '/spa/catalog', '/mappa_tavoli', '/spa/communications']
    .find((path) => canVisit(path));
}

export function canAccessRoute(pathname, actions = [], tenantType) {
  const path = pathname.replace(/\/$/, '') || '/';
  const normalizedTenantType = String(tenantType || '').toUpperCase();
  if ((path === '/spa' || path.startsWith('/spa/')) && normalizedTenantType !== 'SPA') return false;
  if (path === '/spa/communications') return actions.includes('spa-communications:view') || actions.includes('spa-settings:view');
  if (normalizedTenantType === 'SPA' && ['/spa', '/home'].includes(path)) {
    return Boolean(spaHomeRoute((route) => canAccessRoute(route, actions, tenantType)));
  }
  if (normalizedTenantType === 'SPA' && path === '/mappa_tavoli') {
    return actions.includes('spa-catalogs:view') || actions.includes('spa-resources:view') || actions.includes('tables:view');
  }
  const required = path === '/home' && normalizedTenantType === 'SALE_CONGRESSI'
    ? ['reservations:view']
    : routePermissions[path] || dynamicRoutePermissions.find((route) => route.pattern.test(path))?.permissions;
  return Boolean(required && required.every((action) => actions.includes(action)));
}
